/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BreadcrumbNavigationIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Breadcrumb Navigation',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m35.999 18-8.022 9.469a1.5 1.5 0 0 1-1.144.53h-4.226a.5.5 0 0 1-.382-.823L30 18l-7.774-9.177A.5.5 0 0 1 22.607 8h4.226a1.5 1.5 0 0 1 1.144.53Zm-10 0-8.021 9.469a1.5 1.5 0 0 1-1.145.53H1.001a1 1 0 0 1-1-1L0 9a1 1 0 0 1 1-1h15.833a1.5 1.5 0 0 1 1.145.53ZM7.501 18A2.5 2.5 0 1 0 5 20.5 2.5 2.5 0 0 0 7.5 18Zm6.5 0a2.5 2.5 0 1 0-2.5 2.5A2.5 2.5 0 0 0 14 18Zm6.5 0a2.5 2.5 0 1 0-2.5 2.5 2.5 2.5 0 0 0 2.5-2.5Z"
    />
  </svg>`;
};
